/**
 * OIDC設定
 * react-oidc-contextのデフォルト動作を使用
 */

import type { AuthProviderProps } from "react-oidc-context";
import { PAGE_PATHS } from "@/config/urls";

type OidcConfig = AuthProviderProps & {
  post_logout_redirect_uri?: string;
  metadata?: {
    token_endpoint?: string;
    [key: string]: unknown;
  };
};

// OIDC設定をキャッシュするための変数
let cachedOidcConfig: OidcConfig | null = null;

/**
 * OIDC設定を取得する関数
 * デフォルトの動作でアクセストークンはメモリ管理
 */
export const getOidcConfig = (): OidcConfig => {
  if (cachedOidcConfig) {
    return cachedOidcConfig;
  }

  // OIDC認証サーバーのURL
  const authority = import.meta.env.VITE_OIDC_AUTHORITY;
  const tokenDomain = import.meta.env.VITE_OIDC_TOKEN_DOMAIN;
  const currentUrl = window.location.origin;

  const settings = {
    authority,
    client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
    redirect_uri: `${currentUrl}${PAGE_PATHS.CALLBACK}`,
    post_logout_redirect_uri: `${currentUrl}`,
    // 必要なアクセストークンのスコープを指定する
    scope: "openid email profile api:read themes:read",
    response_type: "code",
    usePkce: true,
    automaticSilentRenew: false,
    loadUserInfo: false,
    // 明示的にfetchリクエストにcredentialsを含めるように設定
    fetchRequestCredentials: "include",

    metadata: {
      authorization_endpoint: `${authority}/oauth/authorize`,
      token_endpoint: `${tokenDomain}/oauth/token`, //ローカル環境ではプロキシを経由させる
      userinfo_endpoint: `${authority}/oauth/userinfo`,
      revocation_endpoint: `${authority}/oauth/revoke`,
      end_session_endpoint: `${authority}/oauth/logout`,
      response_types_supported: ["code"],
      scopes_supported: [
        "openid",
        "email",
        "profile",
        "api:read",
        "themes:read",
      ],
      token_endpoint_auth_methods_supported: [
        "client_secret_post",
        "client_secret_basic",
      ],
    },
  };

  cachedOidcConfig = settings;
  return settings;
};
